import * as React from "react";
import { Dropdown, IDropdownOption, IDropdownStyles, ResponsiveMode } from "@fluentui/react";
import { IMultipleSelectionInput } from "../../../../../interfaces/advancedSearch/IMultipleSelectionInput";
import { LanguageContext } from "../../../../../../../utilities/LocalizationModule";
import { resolveChoiceKey, toChoiceList } from "../../../../helpers/choiceOptionsHelper";

export const ChoicePicker: React.FunctionComponent<IMultipleSelectionInput> = props => {
  const languageStrings = React.useContext(LanguageContext);
  // Choices normally arrive deduped from the field conversion and the cache read; deduping again is cheap insurance against a duplicate key.
  const choices = React.useMemo(() => toChoiceList(props.choices), [props.choices]);
  const [options] = React.useState<IDropdownOption[]>(() => [{ key: null, text: "" }, ...choices.map(item => ({ key: item, text: item }))]);
  const handleOnChange = (event: React.FormEvent<HTMLDivElement>, item: IDropdownOption): void => {
    props.handleValueChange(props.searchInputData?.index, item.key);
  };

  const dropdownStyles: Partial<IDropdownStyles> = { root: { width: "100%" } };
  return (
    <Dropdown
      label={props.displayName}
      placeholder={languageStrings.SelectOption}
      onChange={handleOnChange}
      // A value resolved by the datasource path against a stale cached list may be a padded variant; show the canonical option for it.
      selectedKey={props.searchInputData ? resolveChoiceKey(props.searchInputData.value, choices) : undefined}
      options={options}
      className="xb-sp-input"
      // responsiveMode={ResponsiveMode.small}
      styles={dropdownStyles}
    />
  );
};

export default ChoicePicker;
